import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { CardActions, Switch, Tabs, Tab } from 'react-toolbox';
import Card from 'components/Card';
import cx from 'classnames';
import UserForm from 'components/users/UserForm';
import MessageBox from 'components/MessageBox';
import ColoredButton from 'components/ColoredButton';
import SurfaceTypesCheckbox from 'components/formElements/SurfaceTypesCheckbox';
import FlexBox from 'flexbox-react';
import { ThemeProvider } from 'react-css-themr';
import styles from 'styles/form';
import RTInput from 'styles/input';
import RTDropdown from 'styles/dropdown';
import RTCard from 'styles/card';
import RTTabs from 'styles/tabs';
import { error } from '../../../../../utils';
import RTSwitch from 'styles/switch';
import IQMType from 'types/iqm';

const theme = { RTInput, RTDropdown, RTCard, RTSwitch, RTTabs };

const cancelClass = cx([styles.cancelButton, styles.actionButton]);

class IQMForm extends Component {
  constructor(props) {
    super(props);
    const { iqm } = this.props;
    this.state = {
      iqm: (iqm && {
        ...iqm,
        workroom_ids: iqm.workrooms.map(w => w.id),
        surface_type_ids: iqm.surface_types.map(s => s.id),
      }) || { surface_type_ids: [] },
      userAttributes: {},
    };
    this.handleCanDeliver = this.handleChange.bind(this, 'can_deliver');
  }

  handleChange = (key, value) => {
    const iqm = { ...this.state.iqm };
    iqm[key] = value;
    this.setState({ iqm });
  }

  handleActive = val => this.handleUserChange({ active: val });

  handleSurfaceType = (sfID, checked) => {
    const surfaceTypes = [...(this.state.iqm && this.state.iqm.surface_type_ids)] || [];
    const index = surfaceTypes.indexOf(sfID);
    // REMOVE if surface type is in the current IQM list but was deselected
    if (index > -1 && !checked) surfaceTypes.splice(index, 1);
    // ADD if surface type is NOT in the current IQM list and was selected
    else if (index < 0 && checked) surfaceTypes.push(sfID);
    this.handleChange('surface_type_ids', surfaceTypes);
  }

  handleUserChange = user =>
    this.setState({ userAttributes: { ...this.state.userAttributes, ...user } });

  handleCancel = () => this.props.onCancel();

  handleSave = () => {
    const { id, surface_type_ids, user_id, can_deliver } = this.state.iqm;
    this.props.onSave({
      id,
      surface_type_ids,
      can_deliver,
      user_attributes: { ...this.state.userAttributes, id: user_id },
    });
  }

  renderTitle(iqm, active, isEdit) {
    const { name, can_deliver } = iqm;
    const title = isEdit ? (name || 'Edit IQM') : 'Add IQM';
    const switchClassNames = cx({
      [styles.switchTitleAdd]: !isEdit,
      [styles.switchTitle]: true,
    });
    return (<div>
      <FlexBox justifyContent="space-between" className={styles.divider}>
        <div>
          <h5 className={styles.cardTitle}>{title}</h5>
          <p className={styles.cardSubtitle}>
            Please ensure that all fields contain accurate information
          </p>
        </div>
        <div>
          <Switch
            name="active"
            label="Account Active"
            onChange={this.handleActive}
            className={switchClassNames}
            checked={active}
          />
          <Switch
            name="can_deliver"
            label="Can Deliver"
            onChange={this.handleCanDeliver}
            className={switchClassNames}
            checked={can_deliver}
          />
        </div>
      </FlexBox>
    </div>);
  }

  render = () => {
    const { iqm, userAttributes } = this.state;
    const { errors, activeTab, onTabChange } = this.props;
    const isEdit = !!iqm.id;
    const gError = error('global', errors);
    return (<ThemeProvider theme={theme}>
      <Card>
        {this.renderTitle(
          iqm,
          Object.prototype.hasOwnProperty.call(userAttributes, 'active')
            ? userAttributes.active : iqm.active, isEdit,
        )}
        {gError ? <MessageBox error message={gError} /> : null}
        <Tabs index={activeTab} onChange={onTabChange} className={RTTabs.absoluteTabs}>
          <Tab label="Basic Info">
            <UserForm
              user={isEdit ? iqm : null}
              errors={errors}
              onChange={this.handleUserChange}
              leadCertField
            >
              <SurfaceTypesCheckbox
                selectedSurfaceTypes={iqm.surface_type_ids}
                error={error('surface_types', errors)}
                onChange={this.handleSurfaceType}
              />
            </UserForm>
          </Tab>
        </Tabs>
        <FlexBox justifyContent="flex-end" flexWrap="wrap">
          <CardActions className={styles.actionsWrapper}>
            <ColoredButton
              className={cancelClass}
              responsive
              color="gray"
              label="Cancel"
              onClick={this.handleCancel}
            />
            <ColoredButton
              className={styles.actionButton}
              responsive
              color="green"
              label={isEdit ? 'Save Changes' : 'Add IQM'}
              onClick={this.handleSave}
            />
          </CardActions>
        </FlexBox>
      </Card>
    </ThemeProvider>);
  }
}

IQMForm.propTypes = {
  errors: PropTypes.object,
  iqm: IQMType,
  onCancel: PropTypes.func,
  onSave: PropTypes.func,
  activeTab: PropTypes.number,
  onTabChange: PropTypes.func,
};

export default IQMForm;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/iqms/components/IQMForm.jsx